export const termsHtml = (logo) => {
    return (`
    
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Votiamo - Terms and Conditions</title>
    <style>
        body {
            font-family: Arial, sans-serif;
            line-height: 1.6;
            margin: 0;
            padding: 0 20px;
            background-color: #f9f9f9;
        }
        header {
            text-align: center;
            background-color: #fff;
            color: #124559;
            padding: 20px 0;
        }
        h1 {
            margin: 0;
        }
        section {
            margin: 20px 0;
            padding: 20px;
            background: white;
            border: 1px solid #ddd;
            border-radius: 5px;
        }
        h2 {
            color: #124559;
            margin-top: 0;
        }
        ul {
            padding-left: 20px;
        }
        li {
            margin-bottom: 10px;
        }
        footer {
            text-align: center;
            margin: 20px 0;
            color: #777;
        }
        a {
            color: #124559;
        }
    </style>
</head>
<body>
<header>
    <img src="${logo}" alt="Votiamo Logo" style="max-width: 150px; margin: 20px auto; display: block;">
    <h1>Terms and Conditions</h1>
</header>

    <section>
        <h2>Welcome</h2>
        <p>Welcome to Votiamo. Using the app implies acceptance of the following Terms and Conditions. Please read the following carefully before using the app. If you have any questions, contact our support team.</p>
    </section>

    <section>
        <h2>1. Purpose of the App</h2>
        <p>Votiamo is an application designed to create and participate in surveys interactively. The app provides tools to collect and analyze opinions while ensuring user privacy.</p>
    </section>

    <section>
        <h2>2. Registration and User Data</h2>
        <p>To register and use Votiamo, users must provide some basic information, including:</p>
        <ul>
            <li>Date of birth</li>
            <li>Gender</li>
            <li>City of residence</li>
            <li>Family status</li>
            <li>Education level</li>
        </ul>
        <p>These data are used exclusively for statistical purposes and survey analysis. No verification documents are required for this information, and personal contacts (such as email and phone number) will never be made visible or communicated to survey creators or other users.</p>
    </section>

    <section>
        <h2>3. Privacy and Security</h2>
        <p>Votiamo is committed to protecting user privacy. Users can decide whether to make their profile information visible to other users or hide it. It is also possible to participate anonymously if the survey creator enables this option. Responses provided in anonymous surveys will not be associated with the user's profile or visible to the survey creator. Contact information will never be disclosed to other users.</p>
    </section>

    <section>
        <h2>4. App Features</h2>
        <p>Votiamo offers the following main features:</p>
        <ul>
            <li>Survey Creation: Creators can set up public or private surveys and limit participation based on certain characteristics (e.g., age, city).</li>
            <li>Survey Participation: Users can participate in surveys in private or anonymous mode.</li>
            <li>Advanced Statistics: Survey results can be analyzed through specific filters to obtain detailed analyses.</li>
        </ul>
    </section>

    <section>
        <h2>5. User Responsibilities</h2>
        <p>Votiamo users are required to use the app in compliance with all applicable laws and regulations, as well as these Terms and Conditions. Specific responsibilities are detailed below:</p>
        <ul>
            <li>Data Accuracy: The user is responsible for the truthfulness and accuracy of the information provided during registration and use of the app. The app assumes no responsibility for errors or omissions in the data entered by the user.</li>
            <li>Appropriate Conduct: Users must use the app respectfully and appropriately. It is prohibited to use the app for fraudulent, illegal, or unauthorized purposes. This includes refraining from activities that could damage, disable, or overload our services.</li>
            <li>Survey Content: Survey creators are entirely responsible for the content they publish. They must ensure that their surveys do not contain:
                <ul>
                    <li>Illegal or Unlawful Content: Material that violates applicable laws or regulations.</li>
                    <li>Pornographic or Obscene Content: Sexually explicit material or material that offends common decency.</li>
                    <li>Incitement to Hatred or Violence: Content that promotes discrimination, hatred, racism, xenophobia, extremism, or violence against individuals or groups.</li>
                    <li>Violation of Third-Party Rights: Including, but not limited to, copyright, trademarks, trade secrets, or other intellectual property rights.</li>
                    <li>Fraudulent Content: Promises of fake prizes or prizes that will not be awarded.</li>
                </ul>
            </li>
            <li>Reporting Abuse: Users are encouraged to report any content or behavior they believe violates these Terms and Conditions by contacting our team at support@votiamo.com.</li>
            <li>Consequences of Violations: Violating these Terms may result in:
                <ul>
                    <li>Account Suspension or Deletion: The app may temporarily suspend or permanently delete the user's account without notice.</li>
                    <li>Reporting to Authorities: In case of illegal activities, the app reserves the right to report the user to the competent authorities.</li>
                    <li>Legal Action: The app may take legal action to protect its rights and those of other users.</li>
                </ul>
            </li>
        </ul>
    </section>

    <section>
        <h2>6. Usage Limitations</h2>
        <p>To maintain a safe and respectful environment, the following limitations are established:</p>
        <ul>
            <li>Prohibited Content for Survey Creators:
                <ul>
                    <li>Illegal or Unlawful Content: It is strictly forbidden to create surveys that include illegal material, such as defamation, slander, fraud, invasion of privacy, or any other content that violates laws or regulations.</li>
                    <li>Pornographic or Obscene Content: Publishing surveys with pornographic, obscene content, or that offend common decency is not allowed.</li>
                    <li>Incitement to Hatred or Violence: Any content that incites hatred, violence, or discrimination based on race, ethnicity, nationality, religion, gender, sexual orientation, or disability is prohibited.</li>
                    <li>Violation of Intellectual Property Rights: It is not permitted to use materials protected by copyright, registered trademarks, or other intellectual property rights without the owner's authorization.</li>
                    <li>Fraudulent or Deceptive Content: It is forbidden to promise fake prizes or not award promised prizes in surveys. Such actions are considered fraudulent.</li>
                </ul>
            </li>
            <li>Consequences for Survey Creators:
                <ul>
                    <li>Permanent Ban: Creators who violate these policies will be subject to a permanent ban from the app.</li>
                    <li>Reporting to Authorities: In case of serious violations, such as publishing illegal content, the app will report such activities to the competent authorities.</li>
                    <li>Account Deletion: The app reserves the right to delete survey creators' accounts at its sole discretion, especially in case of repeated or serious violations of the Terms and Conditions.</li>
                </ul>
            </li>
            <li>Limitations for Participating Users:
                <ul>
                    <li>Content Responsibility: The app does not assume responsibility for the content of surveys; this lies entirely with the survey creators themselves.</li>
                    <li>Reporting Inappropriate Content: Users who identify surveys with content that violates these policies are invited to report them immediately to support@votiamo.com.</li>
                    <li>Appropriate Behavior: Users must refrain from any form of abuse, harassment, or inappropriate behavior towards other users or survey creators.</li>
                </ul>
            </li>
            <li>App Rights:
                <ul>
                    <li>Content Removal: The app reserves the right to remove any content that it deems, at its sole discretion, to violate these Terms and Conditions or applicable laws.</li>
                    <li>Account Suspension: The app may suspend or delete user accounts that violate these limitations, without notice and at its discretion.</li>
                    <li>Lack of Liability: The app is not responsible for any loss or damage resulting from the suspension or deletion of accounts due to violations of the Terms and Conditions.</li>
                </ul>
            </li>
            <li>Legitimate Use of the Platform:
                <ul>
                    <li>Prohibition of Illegal Activities: It is forbidden to use the app for illegal or unauthorized purposes, including promoting criminal activities.</li>
                    <li>Prohibition of Manipulation: Users must not attempt to circumvent, disable, or interfere with the app's security features or features that prevent or limit the use or copying of any content.</li>
                    <li>Prohibition of Unauthorized Access: Accessing or attempting to access other users' accounts or systems or networks connected to the app without authorization is not allowed.</li>
                </ul>
            </li>
        </ul>
        <p>We remind you that compliance with these limitations is essential to ensure a positive and safe experience for all Votiamo users. Violating these rules can have serious consequences, including legal action.</p>
    </section>

    <section>
        <h2>7. Intellectual Property</h2>
        <p>All content, trademarks, logos, and features of the app are the property of Votiamo or its licensors. Users may not copy, modify, or distribute the app's content without prior written authorization.</p>
    </section>

    <section>
        <h2>8. Limitation of Liability</h2>
        <p>Votiamo is not responsible for any direct or indirect damages arising from the use of the app. The app provides a platform for creating surveys but is not responsible for the accuracy of survey results or decisions made by users based on those results.</p>
    </section>

    <section>
        <h2>9. Changes to the Terms</h2>
        <p>Votiamo reserves the right to modify these Terms and Conditions at any time. Users will be informed of any changes, which will become effective upon publication.</p>
    </section>

    <section>
        <h2>10. Withdrawal and Account Deletion</h2>
        <p>Users can delete their account at any time. Deletion entails the removal of all personal data associated with the account.</p>
        <p>To prevent fraud related to multiple survey participations, a minimum period of 3 months and a maximum of 6 months is required before a user can re-register to the app using the same contacts (email and phone number). During this period, the user will not be able to create a new account with the same contact information previously used.</p>
        <p>Additional Details:</p>
        <ul>
            <li>Waiting Period: After deleting their account, the user must wait at least 3 months before being able to use the same contacts to create a new account. This period can be extended up to a maximum of 6 months at Votiamo's discretion, in order to prevent abuse and ensure the integrity of surveys.</li>
            <li>Registration Restrictions: During the waiting period, any attempt to register with the same contacts will be blocked, and the user will receive a notification informing them of the remaining period required before they can create a new account.</li>
            <li>Exceptions: In particular cases, Votiamo reserves the right to reduce or extend the waiting period based on the nature of user requests or in response to suspicious behavior. Users will be informed of changes via email or notifications within the app.</li>
            <li>Account Recovery: If a user wishes to recover their account before the waiting period is completed, they can contact the Votiamo support team. Account reactivation will be evaluated on a case-by-case basis and is not guaranteed.</li>
        </ul>
        <p>These measures are implemented to ensure a safe environment and prevent abuse, ensuring that survey participation is fair and representative.</p>
        <p>If you have further questions regarding the account deletion process or registration restrictions, we invite you to contact our support team at <a href="mailto:support@votiamo.com">support@votiamo.com</a>.</p>
    </section>

    <section>
        <h2>11. Contacts</h2>
        <p>For any questions or to request assistance, users can contact the Votiamo support team through the contact form (Ticket) available within the app or by writing to support@votiamo.com.</p>
    </section>

    <section>
        <h2>Acceptance of Terms</h2>
        <p>By using the Votiamo app, the user agrees to comply with these Terms and Conditions. If the user does not accept one or more points of these Terms, they are invited not to use the app.</p>
        <p>Thank you for choosing Votiamo.</p>
    </section>

    <footer>
        <p>&copy; 2026 Votiamo. All rights reserved.</p>
    </footer>
</body>
</html>

`)
};